import { Currency } from '../config/i18nConfig'
import store from '../store'

export const getCurrency = (alpha: string): Currency => {
    return (store?.getState().i18n.currencies.data || []).find(currency => currency.alpha === alpha)
}
